/**
 * Ambient – three softly blurred, slowly floating color pools plus a static
 * vignette. Together they replace flat black with a cinematic, layered dark.
 */
export default function Ambient() {
  return (
    <>
      <div className="ambient-glow ambient-glow-1" aria-hidden="true" />
      <div className="ambient-glow ambient-glow-2" aria-hidden="true" />
      <div className="ambient-glow ambient-glow-3" aria-hidden="true" />
      <div className="vignette-overlay" aria-hidden="true" />
    </>
  );
}
